export default `vec3 palette(float t, vec3 a, vec3 b, vec3 c, vec3 d) {
    
    
    return a + b * cos(6.28318 * (c * t + d));
}

vec3 gradientMap(float t, vec3 color1, vec3 color2, vec3 color3) {
    if (t < 0.5) {
        return mix(color1, color2, t * 2.0);
    } else {
        return mix(color2, color3, (t - 0.5) * 2.0);
    }
}

vec3 gradientMap5(float t, vec3 c1, vec3 c2, vec3 c3, vec3 c4, vec3 c5) {
    t = clamp(t, 0.0, 1.0);
    if (t < 0.25) {
        return mix(c1, c2, t * 4.0);
    } else if (t < 0.5) {
        return mix(c2, c3, (t - 0.25) * 4.0);
    } else if (t < 0.75) {
        return mix(c3, c4, (t - 0.5) * 4.0);
    } else {
        return mix(c4, c5, (t - 0.75) * 4.0);
    }
}

vec3 paletteDeepOcean(float t) {
    
    t = clamp(t, 0.0, 1.0);
    
    t = smoothstep(0.05, 0.95, t);
    vec3 c1 = vec3(0.03, 0.06, 0.12); 
    vec3 c2 = vec3(0.06, 0.16, 0.35); 
    vec3 c3 = vec3(0.08, 0.35, 0.58); 
    vec3 c4 = vec3(0.10, 0.65, 0.65); 
    vec3 c5 = vec3(0.85, 0.95, 0.98); 
    vec3 col = gradientMap5(t, c1, c2, c3, c4, c5);
    
    col = pow(col, vec3(0.9));
    return col;
}

vec3 paletteMoltenLava(float t) {
    return palette(t,
        vec3(0.5, 0.3, 0.2),  
        vec3(0.5, 0.3, 0.2),  
        vec3(1.0, 1.0, 0.5),  
        vec3(0.8, 0.2, 0.0)   
    );
}

vec3 paletteElectric(float t) {
    return palette(t,
        vec3(0.5, 0.5, 0.5),  
        vec3(0.5, 0.5, 0.5),  
        vec3(1.0, 1.0, 1.0),  
        vec3(0.0, 0.33, 0.67) 
    );
}

vec3 paletteOrganic(float t) {
    return palette(t,
        vec3(0.4, 0.5, 0.3),  
        vec3(0.3, 0.4, 0.2),  
        vec3(1.0, 1.0, 0.5),  
        vec3(0.2, 0.4, 0.0)   
    );
}

vec3 paletteMonochrome(float t) {
    return palette(t,
        vec3(0.3, 0.3, 0.3),  
        vec3(0.4, 0.4, 0.5),  
        vec3(1.0, 1.0, 1.0),  
        vec3(0.0, 0.0, 0.3)   
    );
}

vec3 paletteDeepAbyss(float t) {
    t = clamp(t, 0.0, 1.0);
    t = smoothstep(0.02, 0.98, t);
    vec3 c1 = vec3(0.010, 0.018, 0.030); 
    vec3 c2 = vec3(0.020, 0.060, 0.110); 
    vec3 c3 = vec3(0.030, 0.120, 0.180); 
    vec3 c4 = vec3(0.050, 0.220, 0.220); 
    vec3 c5 = vec3(0.300, 0.600, 0.750); 
    vec3 col = gradientMap5(t, c1, c2, c3, c4, c5);
    col = pow(col, vec3(0.95));
    return col;
}

vec3 paletteTropicalSea(float t) {
    t = clamp(t, 0.0, 1.0);
    t = smoothstep(0.0, 1.0, t);
    vec3 c1 = vec3(0.020, 0.150, 0.180); 
    vec3 c2 = vec3(0.050, 0.450, 0.550); 
    vec3 c3 = vec3(0.050, 0.750, 0.750); 
    vec3 c4 = vec3(0.450, 0.900, 0.750); 
    vec3 c5 = vec3(0.980, 0.980, 0.850); 
    vec3 col = gradientMap5(t, c1, c2, c3, c4, c5);
    
    col = mix(col, vec3(1.0, 0.97, 0.92), smoothstep(0.8, 1.0, t) * 0.25);
    return col;
}

vec3 colorOrbitTrapPoint(float minDist, int paletteId) {
    float t = clamp(minDist * 0.5, 0.0, 1.0);

    if (paletteId == 0) return paletteDeepOcean(t);
    if (paletteId == 1) return paletteMoltenLava(t);
    if (paletteId == 2) return paletteElectric(t);
    if (paletteId == 3) return paletteOrganic(t);
    if (paletteId == 5) return paletteDeepAbyss(t);
    if (paletteId == 6) return paletteTropicalSea(t);
    return paletteMonochrome(t);
}

struct PlaneTraps {
    float x; 
    float y; 
    float z; 
};

vec3 colorOrbitTrapPlanes(PlaneTraps traps, int paletteId) {
    
    float minTrap = min(min(traps.x, traps.y), traps.z);
    float t = clamp(minTrap, 0.0, 1.0);

    if (paletteId == 0) return paletteDeepOcean(t);
    if (paletteId == 1) return paletteMoltenLava(t);
    if (paletteId == 2) return paletteElectric(t);
    if (paletteId == 3) return paletteOrganic(t);
    if (paletteId == 5) return paletteDeepAbyss(t);
    if (paletteId == 6) return paletteTropicalSea(t);
    return paletteMonochrome(t);
}

vec3 colorByDistance(float dist, float maxDist, int paletteId) {
    float t = clamp(dist / maxDist, 0.0, 1.0);

    if (paletteId == 0) return paletteDeepOcean(t);
    if (paletteId == 1) return paletteMoltenLava(t);
    if (paletteId == 2) return paletteElectric(t);
    if (paletteId == 3) return paletteOrganic(t);
    if (paletteId == 5) return paletteDeepAbyss(t);
    if (paletteId == 6) return paletteTropicalSea(t);
    return paletteMonochrome(t);
}

vec3 colorBySteps(float steps, float maxSteps, int paletteId) {
    float t = clamp(steps / maxSteps, 0.0, 1.0);

    if (paletteId == 0) return paletteDeepOcean(t);
    if (paletteId == 1) return paletteMoltenLava(t);
    if (paletteId == 2) return paletteElectric(t);
    if (paletteId == 3) return paletteOrganic(t);
    if (paletteId == 5) return paletteDeepAbyss(t);
    if (paletteId == 6) return paletteTropicalSea(t);
    return paletteMonochrome(t);
}

vec3 colorByNormal(vec3 normal) {
    
    return normal * 0.5 + 0.5;
}

vec3 colorCombined(float orbitTrap, float dist, vec3 normal, int paletteId) {
    
    vec3 colorA = colorOrbitTrapPoint(orbitTrap, paletteId);
    vec3 colorB = colorByDistance(dist, 10.0, paletteId);

    
    float blend = abs(normal.y) * 0.5 + 0.5;
    return mix(colorA, colorB, blend);
}

vec3 hsv2rgb(vec3 c) {
    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
}

vec3 rgb2hsv(vec3 c) {
    vec4 K = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);
    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));
    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));

    float d = q.x - min(q.w, q.y);
    float e = 1.0e-10;
    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);
}`